<app-dynamic-table
  *ngIf="!loading"
  [columns]="columns"
  [rows]="users"
  [tableSizeClass]="'impersonate-user-page-table'"
  [defaultColumns]="defaultColumns"
  [selectedFilterName]="selectedFilterName"
  [useExternalApi]="true"
  [totalCount]="totalCount"
  [dataTableState]="dataTableState"
  [filters]="filters"
  [showColumnsSettingsBtn]="false"
  [showSaveDatatableFilterBtn]="true"
  [gridSettingsChanged]="!!datatableStateFromStorage"
  (dataTableStateEvent)="getDataTableState($event)"
  (actionButtonEvent)="onActionButtonClick($event)"
  (saveDataTableSettingsEvent)="onSaveDatatableSettings($event)"
  (updateDataTableSettingsEvent)="onUpdateDatatableSettings($event)"
>
</app-dynamic-table>
